export const Errors = {
  noAccounts: 'Accounts could not be fetched',
  default:
    'Oops something went wrong. Try to login again by providing your email address or contact us at support@stessa.com.',
};
